import PuxTranslate from "../../PuxTranslate/PuxTranslate.vue";

import UIComponentMixin from "../UIComponentMixin";

// @vue/component
export default {
  name: "UiOneCheckbox",
  components: {
    PuxTranslate,
  },
  mixins: [
    UIComponentMixin,
  ],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    statusChecked() {
      return this.model === true;
    },

    labelLocal() {
      if (this.options.required) {
        return this.addAsteriskToLastTag(this.options.label);
      }

      return this.options.label;
    },
  },
  methods: {
    toggleModel($event) {
      if (this.isDisabled) {
        return;
      }
      setTimeout(() => {
        const MODEL = !this.statusChecked;
        this.input({
          model: MODEL,
          id: this.options.id,
          $event: $event,
          options: this.options,
        });
        this.change({
          model: MODEL,
          id: this.options.id,
          options: this.options,
          $event: $event,
        });
      });
    },

    addAsteriskToLastTag(html) {
      const closingTagRegex = /<\/[^>]+>/g;
      let lastClosingTagMatch;
      let match = closingTagRegex.exec(html);
      while (match) {
        lastClosingTagMatch = match;
        match = closingTagRegex.exec(html);
      }
      if (!lastClosingTagMatch) {
        return `${ html }*`;
      }
      const insertPosition = lastClosingTagMatch.index;

      return `${ html.slice(0, insertPosition) }*${ html.slice(insertPosition) }`;
    },
  },
};
